import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { database, storage } from "../../firebase";
import AsideContacts from "../../components/AsideContacts";
import AsideNewFeed from "../../components/AsideNewFeed";
import "./addcreditz.css";
import { Form, FormControl } from "react-bootstrap";
import Message from "../../components/Message";
import Placeholder from "../../assets/images/Placeholder.png";
import Footer from "../../components/Footer";
import { allRoles } from "../../assets/constants";
import moment from "moment";
import { css } from "@emotion/react";
import { DotLoader } from "react-spinners";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";




function AddCreditz() {
const categories = ["Music", "Video", "Youtube Video"];
const user_roles = allRoles.map((role) => {
return { value: role, label: role };
 });

  const path = "";
  const features = [
    { label: "Feature", value: "Feature" },
    { label: "Featured", value: "Featured" },
  ];
  const [users, setUser] = useState([]);
  const [userEmailsObj, setUserEmailsObj] = useState([]);
  const [emails, setEmails] = useState([]);
  const [role, SetRole] = useState("");
  const [fields, setFields] = useState([]);
  const [imagelink, SetImageLink] = useState(Placeholder);
  const [loading, SetLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [response, SetResponse] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [participations, setParticipations] = useState([]);
  const [usernames, Setusernames] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [firebaseimagelink, setFirebaseimagelink] = useState("");
  const [previewurl, setPreviewUrl] = useState("");
  const [spotifylink, setSpotifyLink] = useState("");
  const [fields2, setFields2] = useState([]);
  const [show, setShow] = useState(false);
  const [directorname, setDirectorname] = useState("");
  const [youtubeSong, setYoutubeSong] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [creditz, setCreditz] = useState([]);
  const [creditz2, setCreditz2] = useState([]);

  async function uploadImage(imagelink) {
    var remoteimageurl = imagelink;
     fetch(remoteimageurl)
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        storage
          .ref("creditz_images")
          .child(`/${new Date().getTime()}`)
          .put(blob)
          .then(function (snapshot) {
            return snapshot.ref.getDownloadURL();
          })
          .then((url) => {
           
            setFirebaseimagelink(url);
            setMessage(null);
          });
      })
      .catch((error) => {
        console.error(error);
      });
      
  }
  function handleAdd2() {
    const blandCreditz = {
      role: "",
      email: "",
      selectedRole: { value: "", label: "" },
    };

    setCreditz2([...creditz2, { ...blandCreditz }]);
    const obj = { label: "", value: "" };
    const values = [...fields2];
    values.push(obj);
    setFields2(values);
  }

  function handleAdd() {
    const blandCreditz = {
      role: "",
      email: "",
      participation: "",
      selectedParticipation: { value: "", label: "" },
      selectedUsername: { value: "", label: "" },
      selectedRole: { value: "", label: "" },
    };

    setCreditz([...creditz, { ...blandCreditz }]);
    const obj = { label: "", value: "" };
    const values = [...fields];
    values.push(obj);
    setSelectedEmails([...selectedEmails, { ...obj }]);
    setParticipations([...participations, { ...obj }]);
    let index = fields.length - 1;

    if (fields.length === 0) {
      setFields(values);
    } else if (creditz[index].participation == "") {
      setMessage("Participation is Required");
    } else if (creditz[index].role == "") {
      setMessage("Role is Required");
    } else if (creditz[index].email == "") {
      setMessage("Username is Required");
    } else {
      setFields(values);
      setMessage(null);
    }
    setSelectedRoles([...selectedRoles, obj]);
  }
  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
    creditz.pop();
  }
  function handleRemove2(i) {
    const values = [...fields2];
    values.splice(i, 1);
    setFields2(values);
  }

  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [task, SetTask] = useState({
    myrole: allRoles[0],
    category: categories[0],
    artistname: "",
    trackname: "",
    feature: features[0],
  });

  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));

  function getUserData() {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + currentUser.uid).once("value", (snap) => {
        SetRole(snap.val());
      });
    });
  }
  function getUsers(userRole) {
    return database
      .ref(`/users`)
      .once("value")
      .then(async (snapshot) => {
        const array = [];
        snapshot.forEach((childSnapshot) => {
          array.push(childSnapshot.val());
        });
        setUser(array);
        const emailsObj = [];
        array.forEach(({ email, uid, accountType, fullName }) => {
          if (fullName && uid && accountType) {
            emailsObj.push({ label: fullName, value: uid, accountType, email });
          }
        });
        setUserEmailsObj(emailsObj);
      });
  }

  async function Publish() {
    let index = fields.length - 1;
    if (task.artistname == "") {
      setMessage("ArtistName is Required");
    } else if (task.category === "Youtube Video" && directorname == "") {
      setMessage("Director Name is Required");
    } else if (task.category === "Youtube Video" && youtubeUrl == "") {
      setMessage("Youtube URL is Required");
    } else if (task.category != "Youtube Video" && task.trackname == "") {
      setMessage("TrackName is Required");
    } else if (imagelink == Placeholder) {
      setMessage("Image is Required");
    } else if (creditz.length > 0 && creditz[index].participation == "") {
      setMessage("Participation is Required");
    } else if (creditz.length > 0 && creditz[index].role == "") {
      setMessage("role is Required");
    } else if (creditz.length > 0 && creditz[index].email == "") {
      setMessage("Username is Required");
    } else if (firebaseimagelink === "") {
      setMessage("Setting up Image Please wait");
    } else {
      setMessage(null);
      SetLoading(true);
      let types = "";
      if (task.category === "Music" || task.category === "Video") {
        types = "Spotify";
      } else {
        types = "Youtube";
      }
      let preview = "";
      let spotify = "";
      let youtubesong = "";
      let directornames = "";

      if (previewurl && task.category != "Youtube Video") {
        preview = previewurl;
      } else if (task.category === "Youtube Video") {
        preview = youtubeUrl;
      }
      if (spotifylink) {
        spotify = spotifylink;
      } else {
        spotify = "";
      }
      if (task.category === "Youtube Video") {
        youtubesong = youtubeSong;
        directornames = directorname;
      } else {
        youtubesong = "";
        directornames = "";
      }
       let split=[];
       let splitAnd=[];
      let data=[];
      if (youtubeUrl != "") {
        split = youtubeUrl.split("=");
      } else {
        split[1] = "";
      }
      if(split[1].includes("channel")){
        data=split[1].split("&")
        }
        else{
          data.push(split[1])
        }
      

      return database
        .ref("creditz/")
        .push({
          category: task.category,
          artistname: task.artistname,
          trackname: task.trackname,
          role: task.myrole,
          uid: currentUser.uid,
          albumImage: firebaseimagelink,
          publishedAt: moment().toDate().getTime(),
          publishedBy: currentUser.firstName + "" + currentUser.lastName,
          type: types,
          previewurl: preview,
          spotifylink: spotify,
          username: currentUser.fullName,
          youtubetitle: youtubesong,
          directorname: directornames,
          youtubevideoid:data[0]
        })
        .then((pushed_user) => {
          creditz.map((email) => {
            return database.ref("user-creditz/" + pushed_user.key).push({
              email: email.email,
              status: "Pending ",
              credid: pushed_user.key,
              participation: email.participation,
              role: email.role,
              username: email.username,
            });
          });
          creditz2.map((email) => {
            database.ref("user-creditz/" + pushed_user.key).push({
              email: email.email,
              status: "Pending ",
              credid: pushed_user.key,
              role: email.role,
            });
            const config = {
              headers: {
                "Access-Control-Allow-Headers": "privatekey",
              },
            };
            axios.post(
              `https://us-central1-creditzmusic.cloudfunctions.net/sendMail?dest=${email.email}`,
              {
                email: currentUser.email,
                title: task.trackname,
              },
              config
            );
          });
          notifications(pushed_user.key);
          SetTask({
            ...task,
            artistname: "",
            trackname: "",
            category: categories[0],
          });
          setFirebaseimagelink("");
          SetImageLink(Placeholder);
          setYoutubeUrl("")
          setFields([]);
          toast.success("Your Creditz is now Published 🎤 ", {
            autoclose: true,
          });
          setCreditz([]);
          SetLoading(false);
        });
    }
  }
  function notifications(key) {
    creditz.map((email) => {
      return database.ref("Notifications/").child(email.uid).child(key).set({
        sender: currentUser.uid,
        status: "Pending",
        credid: key,
        type: "Creditz",
        timestamp: moment().toDate().getTime(),
        isDeleted: "false",
      });
    });
  }
  let myArr = [];
  let newArr=[];
  let data=[];
  async function getYoutubeData() {
    
    
    if (youtubeUrl != "") {
      myArr = youtubeUrl.split("=");
    } else {
      myArr[1] = "";
    }
    if(myArr[1].includes("channel")){
      newArr=myArr[1].split("&")
      data=myArr[1].split("&")
      }
      else{
        data.push(myArr[1])
      }
    await axios
      .get(
        `https://us-central1-creditzmusic.cloudfunctions.net/YoutubeApi?id=${data[0]}`
      )
      .then(({ data }) => {
        if (data.length) {
          let image = data[0].snippet.thumbnails.standard.url;
          let title = data[0].snippet.title;
          SetImageLink(image);
          setFirebaseimagelink(image)
          setYoutubeSong(title);
        }
      })
      .catch((error) => {
        setMessage(error);
      });
  }
  async function getSpotifyData() {
    const config = {
      headers: {
        "Access-Control-Allow-Headers": "privatekey",
      },
    };
    await axios
      .get(
        `https://us-central1-creditzmusic.cloudfunctions.net/httpsSpotifyToken-spotifyToken/searchTrackArtist?artist=${task.artistname}&track=${task.trackname}`,
        config
      )
      .then((response) => {
        setMessage(null);
        SetResponse(response.data.Tracks.tracks.items[0]);
        SetImageLink(response.data.Tracks.tracks.items[0].album.images[1].url);
        uploadImage(response.data.Tracks.tracks.items[0].album.images[1].url)
        setPreviewUrl(response.data.Tracks.tracks.items[0].preview_url);
        setSpotifyLink(
          response.data.Tracks.tracks.items[0].external_urls.spotify
        );
      })
      .catch((error) => {
        setMessage("Artist Name or Track Name is Invalid");
      });
    SetLoading(false);

  }

  function onKeyPress() {
    if (task.category != "Youtube Video") {
      getSpotifyData();
    } else {
      getYoutubeData();
    }
  }

  function albumToastToggle() {
    toast.info("    ℹ️ Searching for album artwork .. ", { autoclose: true });
  }

  function videoToastToggle() {
    toast.info("    ℹ️ Searching for video .. ", { autoclose: true });
  }

  function onBlur() {
    toast.info("    ℹ️ Searching for album artwork .. ", { autoclose: true });
    if (task.category != "Youtube Video") {
      getSpotifyData();
    } else {
      getYoutubeData();
    }
  }
  useEffect(() => {
    getUserData();
    getUsers(usernames);
  }, []);

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: purple;
    color: purple;
    opacity: 0.5;
  `;

  let [color] = useState();
    const opts = {
    height: "390",
    width: "640",
    playerVars: {
      autoplay: 1,
    },
  };

  return loading == true ? (
    <DotLoader color={color} css={override} size={100} color={"#7444C0"} />
  ) : (
    <>
      {/* Left Aside */}
      <AsideNewFeed></AsideNewFeed>

      <section className="main-content ">
        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-5">
              <div className="card border-0 rounded-xl shadow-xs overflow-hidden mb-3">
                <div className="card-header d-flex align-items-center bg-primary px-4 py-2 fw-bold text-white">
                  <Link
                    to="/Creditz"
                    className="d-inline-flex align-middle text-white py-3 pe-4"
                  >
                    <svg className="icon icon-8x">
                      <use href="#icon_arrowback"></use>
                    </svg>
                  </Link>
                  Add Creditz
                </div>
              </div>
              <div className="card border-0 rounded-xl shadow-xs">
                <div className="card-body p-3 p-sm-4">
                  <div className="mb-2">
                    <select
                      onChange={(e) => {
                        SetTask({ ...task, category: e.target.value });
                      }}
                      className="form-select form-control form-select-lg mmw-120 fw-bold"
                    >
                      {categories.map((cat) => (
                        <option key={cat} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="row g-4">
                    <div
                      className="col-12 col-mdt-4 col-xl-4 mb-3 pt-2"
                      style={{ height: "100%" }}
                    >
                      <img
                        src={imagelink && imagelink}
                        className="w-100 rounded"
                      />
 {/*Video Url*/}        {youtubeUrl != '' ? 
                    <button onClick={()=>window.open(youtubeUrl)} className="btn btn-primary fw-medium rounded-pill px-3" style={{marginTop:"8px",marginLeft:'5px'}}>
                    View
                     </button> :    ""  
                    }

                    </div>
                    <div className="col-12 col-md-8 col-xl-8 mb-3">
                      <div className="row g-4">
                        <div className="col-md-12">
                          {message && (
                            <Message variant="danger">{message}</Message>
                          )}
                          <label
                            htmlFor="inputmanagement"
                            className="form-label fw-semibold fs-13 text-muted"
                          >
                            My Role
                          </label>
                          <select
                            onChange={(e) =>
                              SetTask({ ...task, myrole: e.target.value })
                            }
                            className="form-select form-select-lg form-control"
                            id="inputmanagement"
                          >
                            {allRoles.map((role) => (
                              <option key={role} value={role}>
                                {role}
                              </option>
                            ))}
                          </select>
                        </div>
                        {task.category === "Youtube Video" ? (
                          <div className="col-md-12">
                            <label
                              id="youtubelabel"
                              className="form-label fw-semibold fs-13 text-muted"
                            >
                              Youtube URL
                            </label>
 {/* youtubevideourl */}     <input
                              type="text"
                              className="form-control form-control-lg"
                              id="youtubeurl"
                              name="youtubeurl"
                              onBlur={onBlur}
                              value={youtubeUrl}
                              onChange={(e) => setYoutubeUrl(e.target.value)}
                              placeholder="Youtube URL"
                            />
                          </div>
                        ) : (
                          ""
                        )}



                        <div className="col-md-12">
                          <label
                            htmlFor="artistname"
                            className="form-label fw-semibold fs-13 text-muted"
                          >
                            Artist Name
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-lg"
                            name="artistname"
                            value={task.artistname}
                            onChange={(e) =>
                              SetTask({ ...task, artistname: e.target.value })
                            }
                            onBlur={albumToastToggle}
                            placeholder="Name of Artist"
                          />
                        </div>


                        {task.category === "Youtube Video" ? (
                          <div className="col-md-12">
                            <label
                              htmlFor="directorname"
                              className="form-label fw-semibold fs-13 text-muted"
                            >
                              Director Name
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              name="directorname"
                              value={directorname}
                              onChange={(e) => setDirectorname(e.target.value)}
                              onBlur={videoToastToggle}
                              placeholder="Name of Director"
                            />
                          </div>
                        ) : (
                          <div className="col-md-12">
                            <label
                              htmlFor="trackname"
                              className="form-label fw-semibold fs-13 text-muted"
                            >
                              Track Name
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              name="trackname"
                              value={task.trackname}
                              onChange={(e) =>
                                SetTask({ ...task, trackname: e.target.value })
                              }
                              onKeyPress={onKeyPress}
                              placeholder="Name of Track"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <h5 className="fw-bold pt-4 mb-3">Creditz</h5>
                  <div className="row">
                    {fields.map((field, idx, label) => {
                      return (
                        <div key={`${field}-${idx},${label}`}>
                          <div className="col-md-12">
                            <label
                              htmlFor="inputfeatures"
                              className="form-label fw-semibold fs-13 text-muted"
                            >
                              Participation
                            </label>
                          </div>
                          <div className="col-md-5 mb-1">
                            <Select
                              classNamePrefix="select with email"
                              options={features}
                              onChange={(e) => {
                                let currentCredit = creditz[idx];

                                currentCredit = {
                                  ...currentCredit,
                                  participation: e.value,
                                  selectedParticipation: {
                                    value: e.value,
                                    label: e.value,
                                  },
                                };
                                const newCreitz = creditz.map((cedit, i) => {
                                  if (idx === i) {
                                    return currentCredit;
                                  }
                                  return cedit;
                                });
                                setCreditz([...newCreitz]);
                              }}
                              value={creditz[idx].selectedParticipation}
                            />
                          </div>
                          <div style={{ display: "flex" }}>
                            <div className="col-md-5 mb-1">
                              <label
                                htmlFor="inputmanagement"
                                className="form-label fw-semibold fs-13 text-muted"
                              >
                                Role
                              </label>

                              <div className="col-md-12 mb-1">
                                <Select
                                  classNamePrefix="select with email"
                                  options={user_roles}
                                  onChange={(e) => {
                                    let currentCredit = creditz[idx];
                                    currentCredit = {
                                      ...currentCredit,
                                      role: e.value,
                                      selectedRole: {
                                        label: e.value,
                                        value: e.value,
                                      },
                                    };
                                    const newCreitz = creditz.map(
                                      (cedit, i) => {
                                        if (idx === i) {
                                          return currentCredit;
                                        }
                                        return cedit;
                                      }
                                    );
                                    setCreditz([...newCreitz]);
                                    getUsers(e.label);
                                  }}
                                  value={creditz[idx].selectedRole}
                                />
                              </div>
                            </div>
                            <div
                              className="col-md-5 mb-1"
                              style={{ paddingTop: "3.3%" }}
                            >
                              <Select
                                classNamePrefix="select with email"
                                name="email"
                                options={userEmailsObj}
                                onChange={(e) => {
                                  let currentCredit = creditz[idx];
                                  currentCredit = {
                                    ...currentCredit,
                                    email: e.email,
                                    uid: e.value,
                                    username: e.label,
                                    selectedUsername: {
                                      value: e.label,
                                      label: e.label,
                                    },
                                  };
                                  const newCreitz = creditz.map((cedit, i) => {
                                    if (idx === i) {
                                      return currentCredit;
                                    }
                                    return cedit;
                                  });
                                  setCreditz([...newCreitz]);
                                }}
                                value={creditz[idx].selectedUsername}
                              />
                            </div>
                            <div className="col-md-2 mb-1">
                              {fields.length >= 1 ? (
                                <button
                                  onClick={() => handleRemove(idx)}
                                  className="mmwh-38 btn btn-secondary p-0 rounded-pill"
                                  style={{ paddingTop: "3.3%" }}
                                >
                                  <svg className="icon icon-4x">
                                    <use href="#icon_cross"></use>
                                  </svg>
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header>
                      <Modal.Title>Invite Members</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        {fields2.map((field, idx, label) => {
                          return (
                            <div key={`${field}-${idx},${label}`}>
                              <div style={{ display: "flex" }}>
                                <div className="row">
                                  <div className="col-md-12 mb-1">
                                    <label
                                      htmlFor="inputmanagement"
                                      className="form-label fw-semibold fs-13 text-muted"
                                    >
                                      Role
                                    </label>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-5 mb-1">
                                      <Select
                                        classNamePrefix="select with email"
                                        options={user_roles}
                                        onChange={(e) => {
                                          let currentCredit = creditz2[idx];
                                          currentCredit = {
                                            ...currentCredit,
                                            role: e.value,
                                            selectedRole: {
                                              label: e.value,
                                              value: e.value,
                                            },
                                          };
                                          const newCreitz = creditz2.map(
                                            (cedit, i) => {
                                              if (idx === i) {
                                                return currentCredit;
                                              }
                                              return cedit;
                                            }
                                          );
                                          setCreditz2([...newCreitz]);
                                        }}
                                        value={creditz2[idx].selectedRole}
                                      />
                                    </div>
                                    <div
                                      className="col-md-6 mb-1"
                                      style={{ "padding-left": "50px" }}
                                    >
                                      <InputGroup className="mb-3">
                                        <FormControl
                                          placeholder="Email"
                                          aria-label="Email"
                                          aria-describedby="basic-addon1"
                                          value={creditz2[idx].email}
                                          onChange={(e) => {
                                            let currentCredit = creditz2[idx];
                                            currentCredit = {
                                              ...currentCredit,
                                              email: e.target.value,
                                            };
                                            const newCreitz = creditz2.map(
                                              (cedit, i) => {
                                                if (idx === i) {
                                                  return currentCredit;
                                                }
                                                return cedit;
                                              }
                                            );
                                            setCreditz2([...newCreitz]);
                                          }}
                                        />
                                      </InputGroup>
                                    </div>

                                    <div className="col-md-1 mb-1">
                                      {fields2.length >= 1 ? (
                                        <button
                                          onClick={() => handleRemove2(idx)}
                                          className="mmwh-38 btn btn-secondary p-0 rounded-pill"
                                          style={{ paddingTop: "3.3%" }}
                                        >
                                          <svg className="icon icon-4x">
                                            <use href="#icon_cross"></use>
                                          </svg>
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <button
                        className="btn btn-secondary btn-lg px-3 px-sm-4 fw-semibold me-3"
                        onClick={() => {
                          handleAdd2();
                        }}
                      >
                        <svg className="icon icon-5x me-2">
                          <use href="#icon_plus"></use>
                        </svg>{" "}
                        Add
                      </button>

                      <Button variant="primary" onClick={handleClose}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <div className="d-flex justify-content-between mt-4">
                    <button
                      className="btn btn-secondary btn-lg px-3 px-sm-4 fw-semibold me-3"
                      onClick={() => {
                        handleAdd();
                      }}
                    >
                      <svg className="icon icon-5x me-2">
                        <use href="#icon_plus"></use>
                      </svg>{" "}
                      Give Creditz
                    </button>
                    <button
                      className="btn btn-secondary btn-lg px-3 px-sm-4 fw-semibold me-3"
                      onClick={() => {
                        handleShow();
                      }}
                    >
                      <svg className="icon icon-5x me-2">
                        <use href="#icon_plus"></use>
                      </svg>{" "}
                      Invite
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary btn-lg px-3 px-sm-4 fw-semibold"
                      onClick={() => Publish()}
                    >
                      <svg className="icon icon-5x me-3">
                        <use href="#icon_publish"></use>
                      </svg>
                      Publish
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Right Aside */}
      <AsideContacts></AsideContacts>
      <Footer />
    </>
  );
}

export default AddCreditz;
